import type { Language } from '@application/types';
import type { MtSettingsBreederGetProfileQuery } from '@gql/graphql';
import type { MtSettingsBreederPageFormValues } from '@presentation/pages';
import { useMemo } from 'react';

export const useProfileInitialValuesBuilder = (
  profile: MtSettingsBreederGetProfileQuery['accountMe'] | null | undefined,
) => {
  const initialValues = useMemo((): MtSettingsBreederPageFormValues => {
    return {
      language: (profile?.language as Language) ?? undefined,
      contactPreferences: profile?.contactPreferences ?? undefined,
    };
  }, [profile?.contactPreferences, profile?.language]);

  return { initialValues };
};
